<div class="modalPlans">
    <div class="contenidoModal">
      <div class="header">
        <img src= "/assets/icono-plans/alertamin.svg" alt="alerta">
        <img src="/assets/icono/equis.svg" class="cerrar mr-2" (click)="closeModal()" alt=""/>
      </div>
     <div class="bajada">
        <h2 class="copec-bold-18" >{{mensaje ==='alertaCambioSinSap'? 'No es posible acceder al Cambio de Plan':'Cambio de plan'}}</h2>
      <p [innerHTML]="mensajeOption()"></p>    
      </div>
      <div class="botones">     
        <button *ngIf="cambioAplanDuo && mensaje === 'alertaPlanDuo'" type="button" class="cancelar" (click)="closeModal()">Cancelar</button>
        <button  class ="cambiarme" (click)="enviarSolicitudDowngrade()">Aceptar</button>
  
      </div>

</div>
